const createFakeProductToSkeleton = () => {
  return {
    sku: '',
    name: '',
    url: '',
    thumbnail: '',
    hasComboVariation: false,
  }
}

export const createProductsArrayForSkeleton = (length: number) => Array.from({ length: length }, createFakeProductToSkeleton)
